import { render } from "./Organizations.vue?vue&type=template&id=e92e0696&ts=true"
import script from "./Organizations.vue?vue&type=script&lang=ts"
export * from "./Organizations.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__